import angular from "angular";
import StudentDocumentsIndex from "./index/student-documents-index.module";
import SignDocument from "./sign/student-sign-document.module";

function config($stateProvider) {
    $stateProvider.state('drivecoach.student.documents', {
        abstract: true,
        url: '/documents',
        template: '<ui-view/>'
    });
}

config.$inject = ['$stateProvider'];

export default angular
  .module("student.documents", [
    StudentDocumentsIndex.name,
    SignDocument.name
  ])
  .config(config);
